import { Injectable } from '@angular/core';
import { environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { Router } from '@angular/router';
import { IContent } from '../model/content';
import { MessageService } from './message.service';


@Injectable({
  providedIn: 'root'
})
export class ContentService {

  // private token;
  constructor(private http: HttpClient, private router: Router, private msgSer: MessageService) {
  }

  getContentData(): Observable<IContent> {
    return this.http.get(`${environment.apiUrl}content/all-content/` )
       .pipe(map((res: any) => {
         return res.data;
       }));

  }

  //
  // Get Content
  //
  getAllContent( page, per_page, sorting, filtering): Observable<any> {
    let add_url = '';
    if (filtering.title !== '') {
      add_url = add_url + '&title=' + filtering.title;
    }
    if (filtering.type !== undefined) {
      add_url = add_url + '&type=' + filtering.type;
    }

    return this.http.get(`${environment.apiUrl}content/content/` + '?page=' + page
                    + '&per_page=' + per_page + '&sort_by=' + sorting.value + '&sort_type='
                    + sorting.sort + add_url )
       .pipe(map(res => { return res; }));
  }

  //
  // Creates a new Content record
  //
  createContent( form ) {

    return this.http.post(`${environment.apiUrl}content/`, form)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

  //
  // Update a Content record
  //
  saveContent( id, form ) {
    return this.http.post(`${environment.apiUrl}content/` + id, form
    )
    .pipe(
      map((res: any) => {
        if (res.status) {
          return res.status;
        }
      })
    );
  }

  //
  // Retrieve Content with given id
  //
  getContent( id ): Observable <IContent> {
    return this.http.get(`${environment.apiUrl}content/` + id)
        .pipe(
           map((res: any) => {
             if (res.status) {
               return res.data;
             }
           })
        );
  }


  //
  // Delete a new Content record
  //
  deleteContent( id ): Observable <any> {

    return this.http.delete(`${environment.apiUrl}content/` + id)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

}
